import React from 'react';
import { Link } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import { Button, Typography, TextField } from '@material-ui/core';
import background from '../../../Assets/images/trucks-without-background.png';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import HomePageSearch from '../SearchBoxes/HompageSearchBar';
import Modal from '@material-ui/core/Modal';
import classNames from 'classnames';

// import IntegrationReactSelect from '../Select/IntegrationReactSelect';

const useStyles = makeStyles(theme => ({
    root: {
      display: 'flex',
      margin: 'auto',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      height: '50vh',
      // position: "relative",
      backgroundImage: `url(${background})`,
      background: '#ffecd1',
      // opacity: '0.74',
      backgroundPosition: 'center',
      backgroundSize: '70%',
      backgroundRepeat:' no-repeat',
      borderRadius: '0px',
    },

      button: {
        background: '#15616d',
        textTransform: 'capitalize',
        margin: 8,
        minWidth: '12%',
        '&:hover': {
            color: 'white',
            background: '#40916c',
            
        }
    },   

      buttonContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '51%',
        paddingBottom: '18px'
      },

      typoContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        paddingTop: '80px',
        background: '#FFECD1',
        [theme.breakpoints.down('sm')]: {
          paddingRight: theme.spacing(3),
          paddingLeft: theme.spacing(3)
        }
      },

      createAuctionButton: {
        marginTop: '10px',
        padding: '13px 22px',
        color: 'white',
        background: '#ff7d00',
        '&:hover': {
            backgroundColor: '#78290f',
            color: 'white',
        }
    },

      link: {
        color: 'white',
        '&:hover': {
            color: 'white',
            textDecoration: 'none'
        }
    },

    paper: {
      margin: 'auto',
      // position: 'absolute',
      width: 400,
      backgroundColor: theme.palette.background.paper,
      // border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },

    typo: {
      textAlign: 'center',
    },

    welcomeTypo: {
      textAlign: 'center',
      [theme.breakpoints.down('sm')]: {
          lineHeight: '1em',
          fontSize: '50px',
          paddingBottom: theme.spacing(2),
      }
    },

  }));

const BodyOfHomepage = () => {
  const classes = useStyles();

  // const myImage='transport-trucks.jpg'
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };


    return (
        <>
          <Navbar/>
          <div className={classes.typoContainer}>
              <Typography className={classNames(classes.welcomeTypo, classes.typo)} variant='h2'>Welcome to Transporex</Typography>
                <Typography className={classes.typo} variant='h5'>Find verified logistics partners in Europe's Best Logistics platform</Typography>
                <Button size="large" variant='contained' disableRipple='true' className={classes.createAuctionButton}>
                  <Link to={'/signup'} className={classes.link}>Create Auction</Link>
                </Button>
          </div>
          <div className={classes.root}>
              {/* <div className={classes.buttonContainer}>
                <Button color='primary' variant='contained' disableRipple='true' size="medium" className={classes.button}>
                  Where
                </Button>
                <Button color='primary' variant='contained' disableRipple='true' size="medium" className={classes.button}>
                  Search Companies
                </Button>
              </div> */}
              <div style={{width: '100%', paddingBottom: '15%'}}>
                <HomePageSearch/>
              </div>
              
              {/* <div>
                <Button variant='contained' type="button" onClick={handleOpen}>
                  Open Modal
                </Button>
                <Modal style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="simple-modal-title"
                  aria-describedby="simple-modal-description"
                  >
                  <div className={classes.paper}>
                    <TextField  id="outlined-basic" label="Outlined" variant="outlined" />
                    <Button variant="contained" color="primary" style={{padding: '1rem'}}>Place bid</Button>
                  </div>
                </Modal>
            </div> */}
          </div>
          <Footer/>         
        </>
    )
}

export default BodyOfHomepage;
